import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SEOHead from '../../components/SEOHead';

export default function ProblemaPage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "Il Problema - Frammentazione - Vertiix Digital",
    "description": "La frammentazione è strutturale: investimenti senza visione unificata, decisioni al buio, crescita non scalabile. Scopri perché il problema non è tecnico ma strutturale e come risolverlo con un sistema governabile.",
    "author": {
      "@type": "Organization",
      "name": "Vertiix"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Vertiix",
      "logo": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png"
      }
    },
    "datePublished": "2025-01-01",
    "dateModified": new Date().toISOString().split('T')[0]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Il Problema - Frammentazione - Vertiix Digital"
        description="La frammentazione è strutturale: investimenti senza visione unificata, decisioni al buio, crescita non scalabile. Scopri perché il problema non è tecnico ma strutturale e come risolverlo con un sistema governabile."
        keywords="frammentazione marketing, investimenti dispersi, decisioni marketing, crescita scalabile, sistema marketing, problema marketing aziendale"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/problema`}
        ogImage="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png"
        schema={schema}
      />
      
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 py-3 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
              alt="Vertiix" 
              className="h-12 sm:h-16 md:h-20 lg:h-24"
            />
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-700' : 'text-gray-600'}`}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6 lg:gap-12">
            <Link to="/" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Home
            </Link>
            <Link to="/problema" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Il Problema
            </Link>
            <Link to="/vertiix" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Cos'è Vertiix
            </Link>
            <Link to="/come-funziona" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Come Funziona
            </Link>
            <Link to="/accesso" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Come Si Accede
            </Link>
            <Link to="/valutazione" className={`px-5 lg:px-6 py-2.5 lg:py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer text-xs`}>
              VALUTAZIONE
            </Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="px-4 sm:px-6 py-4 space-y-3">
              <Link to="/" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Home
              </Link>
              <Link to="/problema" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Il Problema
              </Link>
              <Link to="/vertiix" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Cos'è Vertiix
              </Link>
              <Link to="/come-funziona" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Funziona
              </Link>
              <Link to="/accesso" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Si Accede
              </Link>
              <Link to="/valutazione" className="block text-center px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer mt-4 text-xs" onClick={() => setMobileMenuOpen(false)}>
                VALUTAZIONE
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero */}
      <section className="min-h-[60vh] flex items-center justify-center bg-gradient-to-br from-[#f0fdf9] to-white pt-20 sm:pt-24 md:pt-32 pb-10 sm:pb-12 md:pb-20 px-4 sm:px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto w-full">
          <div className="max-w-[900px]">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[64px] font-serif font-medium leading-[1.15] mb-6 sm:mb-8 md:mb-10 text-gray-900">
              La Frammentazione<br/>È Strutturale
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl lg:text-[28px] font-light text-gray-600 leading-relaxed max-w-[680px]">
              Non è un problema di impegno o di budget. È un problema di architettura. Senza sistema, ogni investimento diventa una scommessa.
            </p>
          </div>
        </div>
      </section>

      {/* Sintomi Section */}
      <section className="py-12 sm:py-16 md:py-24 lg:py-32 bg-white px-4 sm:px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          
          {/* Sintomo 1 */}
          <div className="mb-16 sm:mb-20 md:mb-32 lg:mb-48 grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-16 items-center">
            <div className="lg:col-span-6">
              <div className="text-xs sm:text-sm font-mono text-[#14B8A6] mb-3 sm:mb-4">01</div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 md:mb-8 text-gray-900">
                Investimenti Senza Visione Unificata
              </h2>
              <p className="text-sm sm:text-base leading-[1.8] text-gray-600 mb-5 sm:mb-6 md:mb-8">
                Le aziende investono in advertising, contenuti, automazioni, CRM, analytics.
Ogni strumento nasce per risolvere un problema specifico.
Ma senza una visione unificata, nessuno governa l'insieme.
Il risultato non è strategia. È accumulo.
              </p>
              <blockquote className="border-l-2 border-[#14B8A6] pl-4 sm:pl-5 md:pl-6 text-sm sm:text-base md:text-lg italic text-gray-700">
                "Ogni fornitore promette risultati.
Ma senza sistema, i risultati non si sommano."
              </blockquote>
            </div>
            <div className="lg:col-span-6">
              <div className="w-full h-[250px] sm:h-[300px] md:h-[400px]">
                <img 
                  src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/c2afef35847c4d486bb09923e0dc72e9.png" 
                  alt="Investimenti Dispersi" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Sintomo 2 */}
          <div className="mb-16 sm:mb-20 md:mb-32 lg:mb-48 grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-16 items-center">
            <div className="lg:col-span-6 lg:order-2">
              <div className="text-xs sm:text-sm font-mono text-[#14B8A6] mb-3 sm:mb-4">02</div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 md:mb-8 text-gray-900">
                Decisioni Prese Senza Lettura Chiara
              </h2>
              <p className="text-sm sm:text-base leading-[1.8] text-gray-600 mb-5 sm:mb-6 md:mb-8">
                I dati esistono.
Ma sono dispersi in dashboard separate, report non confrontabili, metriche che misurano attività e non sistema.

Le decisioni diventano opinioni.
Le strategie reagiscono all'ultimo meeting, non a una lettura del flusso.
              </p>
              <blockquote className="border-l-2 border-[#14B8A6] pl-4 sm:pl-5 md:pl-6 text-sm sm:text-base md:text-lg italic text-gray-700">
                "Senza lettura unificata, ogni scelta è una scommessa. Non una decisione informata."
              </blockquote>
            </div>
            <div className="lg:col-span-6 lg:order-1">
              <div className="w-full h-[250px] sm:h-[300px] md:h-[400px]">
                <img 
                  src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/1808f787fc22b3b50e7b92e880e514f0.png" 
                  alt="Decisioni al Buio" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Sintomo 3 */}
          <div className="mb-16 sm:mb-20 md:mb-32 lg:mb-48 grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-16 items-center">
            <div className="lg:col-span-6">
              <div className="text-xs sm:text-sm font-mono text-[#14B8A6] mb-3 sm:mb-4">03</div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 md:mb-8 text-gray-900">
                Marketing Non Governabile Né Scalabile
              </h2>
              <p className="text-sm sm:text-base leading-[1.8] text-gray-600 mb-5 sm:mb-6 md:mb-8">
                Ogni tentativo di crescita richiede sforzo lineare.
Più budget. Più persone. Più strumenti.

Ma senza infrastruttura, non esiste leva.
La complessità cresce più velocemente dei risultati.
              </p>
              <blockquote className="border-l-2 border-[#14B8A6] pl-4 sm:pl-5 md:pl-6 text-sm sm:text-base md:text-lg italic text-gray-700">
                "Senza architettura, la crescita non scala.
Aumenta solo il carico operativo."
              </blockquote>
            </div>
            <div className="lg:col-span-6">
              <div className="w-full h-[250px] sm:h-[300px] md:h-[400px]">
                <img 
                  src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/a9842db4c77e096c9497e5a0781fbeb0.png" 
                  alt="Crescita Non Scalabile" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Insight Section */}
      <section className="py-12 sm:py-16 md:py-24 lg:py-32 bg-[#f8faf9] px-4 sm:px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto text-center">
          <div className="max-w-[800px] mx-auto">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif font-medium mb-6 sm:mb-8 md:mb-12 text-gray-900 leading-tight">
              Il problema non è tecnico.<br/>È strutturale.
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed mb-8 sm:mb-10 md:mb-16">
              Non si risolve cambiando fornitori. Non si risolve aumentando il budget. Non si risolve assumendo più persone. Si risolve costruendo un sistema che coordina, governa e ottimizza ogni elemento.
            </p>
            <Link 
              to="/vertiix" 
              className="inline-block px-6 sm:px-8 md:px-12 py-3 md:py-4 bg-[#14B8A6] text-white text-xs tracking-[0.5px] uppercase hover:bg-[#0d9488] transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Scopri la Soluzione
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a2332] py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-8 sm:gap-10 md:gap-16 mb-10 sm:mb-12">
            <div className="sm:col-span-2 md:col-span-4">
              <img 
                src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
                alt="Vertiix" 
                className="h-36 sm:h-40 md:h-48 mb-6 sm:mb-7 md:mb-8"
                style={{ filter: 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.6)) drop-shadow(0 0 30px rgba(255, 255, 255, 0.4)) drop-shadow(0 0 45px rgba(255, 255, 255, 0.3))' }}
              />
              <p className="text-xs sm:text-sm text-gray-400 leading-relaxed">Digital Factory per aziende che vogliono governare la crescita, non subirla.</p>
            </div>
            
            <div className="md:col-span-2">
              <h4 className="text-xs sm:text-sm font-semibold text-white mb-4 sm:mb-5 md:mb-6">Navigazione</h4>
              <nav className="space-y-2 sm:space-y-2.5 md:space-y-3">
                <Link to="/" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Home</Link>
                <Link to="/problema" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Il Problema</Link>
                <Link to="/vertiix" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Cos'è Vertiix</Link>
                <Link to="/come-funziona" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Funziona</Link>
                <Link to="/accesso" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Si Accede</Link>
              </nav>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-xs sm:text-sm font-semibold text-white mb-4 sm:mb-5 md:mb-6">Contatti</h4>
              <p className="text-xs sm:text-sm text-gray-400">info@vertiix.ch</p>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-xs sm:text-sm font-semibold text-white mb-4 sm:mb-5 md:mb-6">Azione</h4>
              <Link to="/valutazione" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors mb-3">Valutazione</Link>
              <Link to="/about-vertiix" className="block text-xs sm:text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">About Vertiix</Link>
            </div>
          </div>
          
          <div className="pt-6 sm:pt-7 md:pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-[10px] sm:text-xs text-gray-500 text-center md:text-left">
              © 2025 Vertiix. Sistema operativo della crescita.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <a 
                href="https://ti.chregister.ch/cr-portal/auszug/auszug.xhtml?uid=CHE-410.417.125" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                CHE-410.417.125
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}